import { gql } from '@zenbusiness/application-commons-graphql';

import { ATTRIBUTES_FRAGMENT } from '../fragments/AttributesFragment';
import { UI_INSTRUCTION_FRAGMENT } from '../fragments/UiInstructionFragment';

export const GENERATE_ARTICLE_MUTATION = gql`
  mutation GenerateArticle(
    $identity: CustomerIdentity!
    $input: JSON!
    $threadUuid: UUID!
    $messageUuid: UUID!
  ) {
    generateArticle(
      identity: $identity
      input: $input
      threadUuid: $threadUuid
      messageUuid: $messageUuid
    ) {
      ok
      threadUuid
      data {
        id
        type
        attributes {
          ...AttributesFragment
        }
        meta {
          renderStrategy
        }
      }
      error
      meta
    }
  }
  ${ATTRIBUTES_FRAGMENT}
  ${UI_INSTRUCTION_FRAGMENT}
`;
